define.alias("shared/components/shared/wizard/finish-button", "settings/components/shared/wizard/finish-button");